export default __webpack_public_path__ + "static/media/run-workflow.1b6b2e74.png";